export enum CLASSIFICATION {
  MOST_USED = "MOST_USED",
  NEWLY_ADDED = "NEWLY_ADDED",
  TOP_RATED = "TOP_RATED",
}

export enum TOP_CAROUSEL_IDS {
  TOP_1 = "TOP_1",
  TOP_2 = "TOP_2",
  TOP_3 = "TOP_3",
}

export enum AD_CAROUSEL_IDS {
  AD_1 = "AD_1",
  AD_2 = "AD_2",
  AD_3 = "AD_3",
}
